import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ImageBox } from '@bvt-shared/component/ImageBox';
import { generateUUID } from '@bvt-utils';

/**
 *
 * @param {object} props
 * @param {Array<{
 * name: string
 * total: number
 * icon: string
 * }>} props.data
 */

export default function ProfessionTable(props) {
  const [toggle, setToggle] = useState(false);
  const data = [...(props.data || [])]
    .sort((a, b) => {
      if (toggle) {
        return a.total - b.total;
      } else {
        return b.total - a.total;
      }
    })
    .map((el) => {
      return {
        ...el,
        icon: <ImageBox src={`/assets/professions/${el.icon}.svg`} type='link' />,
      };
    });

  return (
    <div className='feature-griana Profession--table'>
      <div className='feature-griana Profession--table_header'>
        <div className='feature-griana Profession--table_header_left'>
          <div>Rank</div>
          <div>Type</div>
        </div>
        <div
          className='feature-griana Profession--table_header_right'
          onClick={() => setToggle((prev) => !prev)}
        >
          <div className='feature-griana Profession--table_header_right_icon'>
            <svg height='0.5rem' viewBox='0 0 10.227 7.7' width='1rem'>
              <path
                d='M5.9,1.858a1.75,1.75,0,0,1,2.734,0L12,6.058A1.75,1.75,0,0,1,10.63,8.9H3.911A1.75,1.75,0,0,1,2.544,6.058Z'
                fill={toggle ? '#007e75' : '#caced5'}
                transform='translate(-2.157 -1.202)'
              />
            </svg>
            <svg height='0.5rem' viewBox='0 0 10.227 7.7' width='1rem'>
              <path
                d='M3.747.657a1.75,1.75,0,0,1,2.734,0l3.36,4.2A1.75,1.75,0,0,1,8.473,7.7H1.754A1.75,1.75,0,0,1,.387,4.857Z'
                fill={!toggle ? '#007e75' : '#caced5'}
                transform='translate(10.227 7.7) rotate(180)'
              />
            </svg>
          </div>
          <div>Total</div>
        </div>
      </div>
      {data.map(({ name, total, icon, order }, idx) => (
        <div className='feature-griana Profession--table_item' key={generateUUID()}>
          <div className='feature-griana Profession--table_item_left'>
            <div className='feature-griana Profession--table_item_left_number'>
              {order ?? (idx + 1)}
            </div>
            <div className='feature-griana Profession--table_item_left_type'>
              {icon} {name}
            </div>
          </div>
          <div className='feature-griana Profession--table_item_right'>
            {total}
          </div>
        </div>
      ))}
    </div>
  );
}

ProfessionTable.defaultProps = {
  data: [
    {
      name: 'Worker',
      total: 324,
      icon: 'test',
    },
    {
      name: 'Wiraswasta',
      total: 314,
      icon: 'Beach',
    },
    {
      name: 'Religion',
      total: 302,
      icon: 'BeautySalon',
    },
    {
      name: 'Pilot',
      total: 284,
      icon: 'Beach',
    },
    {
      name: 'Pertanian',
      total: 252,
      icon: 'Beach',
    },
    {
      name: 'Pensiunan',
      total: 252,
      icon: 'Beach',
    },
    {
      name: 'Pendidikan',
      total: 237,
      icon: 'Beach',
    },
    {
      name: 'Pelajar',
      total: 218,
      icon: 'Beach',
    },
    {
      name: 'Other',
      total: 206,
      icon: 'Beach',
    },
    {
      name: 'Nelayan',
      total: 201,
      icon: 'Beach',
    },
  ],
};

ProfessionTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      total: PropTypes.number,
      icon: PropTypes.string,
    })
  ),
};
